import { createStore, withProps } from '@ngneat/elf';
import { withRequestsStatus } from '@ngneat/elf-requests';

import { ClientsUnit } from '@store/clients/units/clients-units.model';

export const clientsUnitsDetailsStore = createStore(
  {name: 'clients-units'},
  withProps<Partial<ClientsUnit>>({}),
  withRequestsStatus(),
);
